module.exports = __webpack_public_path__ + "media/images/elionline/icons/side_menu_report_attivo-e9ff17293042b75ba34d244db1444bd7.svg";